export const GET_PRODUCTS = "GET_PRODUCTS";
export const FILTER_PRODUCTS = "FILTER_PRODUCTS";
export const ADD_PRODUCT = "ADD_PRODUCT";
export const EDIT_PRODUCT = "EDIT_PRODUCT";
export const GET_PRODUCT = "GET_PRODUCT";
export const RESET_PRODUCT = "RESET_PRODUCT";
export const PRODUCTS_ERROR = "PRODUCTS_ERROR";
